import {
  AUTH_ERROR,
  LOGIN_SUCCESS,
  LOGOUT,
  USER_LOADED,
} from "../../actions/auth/types";

const initialState = {
  token: localStorage.getItem("token"),
  refresh:localStorage.getItem('refresh'),
  isAuthenticated: true,
  loading: true,
  user: null,
};
export const login = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        token: "Bearer " + payload.access,
        refresh:payload.refresh,
        isAuthenticated: true,
        loading: false,
      };
    case USER_LOADED:
      return {
        ...state,
        isAuthenticated: true,
        loading: false,
        user: payload,
      };

    case AUTH_ERROR:
    case LOGOUT:
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: false,
        user: null,
      };
    default: {
      return state;
    }
  }
};
